import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'zz_admin_token';

export const apiPublic = axios.create({
    baseURL: `${BACKEND}/api`,
    headers: { 'Content-Type': 'application/json' },
});

// Admin axios client — adds Bearer header for /admin/* + handles 401 globally.
export const apiAdmin = axios.create({
    baseURL: `${BACKEND}/api/admin`,
    headers: { 'Content-Type': 'application/json' },
});

apiAdmin.interceptors.request.use((config) => {
    const token = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

apiAdmin.interceptors.response.use(
    (r) => r,
    (error) => {
        if (error?.response?.status === 401) {
            try { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem('zz_admin_user'); } catch (_) { /* noop */ }
            if (onUnauthorized) onUnauthorized();
        }
        return Promise.reject(error);
    },
);

export const TOKEN_STORAGE_KEY = TOKEN_KEY;
